/* REPORT */
export const GET_SALES_REPORT= "GET_SALES_REPORT"
export const GET_SALES_REPORT_SUCCESS = "GET_SALES_REPORT_SUCCESS"
export const GET_SALES_REPORT_FAIL = "GET_SALES_REPORT_FAIL"

export const EXPORT_SALES_REPORT= "EXPORT_SALES_REPORT"
export const EXPORT_SALES_REPORT_SUCCESS = "EXPORT_SALES_REPORT_SUCCESS"
export const EXPORT_SALES_REPORT_FAIL = "EXPORT_SALES_REPORT_FAIL"

export const GET_PRODUCT_SALES_REPORT= "GET_PRODUCT_SALES_REPORT"
export const GET_PRODUCT_SALES_REPORT_SUCCESS = "GET_PRODUCT_SALES_REPORT_SUCCESS"
export const GET_PRODUCT_SALES_REPORT_FAIL = "GET_PRODUCT_SALES_REPORT_FAIL"

export const EXPORT_PRODUCT_SALES_REPORT= "EXPORT_PRODUCT_SALES_REPORT"
export const EXPORT_PRODUCT_SALES_REPORT_SUCCESS = "EXPORT_PRODUCT_SALES_REPORT_SUCCESS"
export const EXPORT_PRODUCT_SALES_REPORT_FAIL = "EXPORT_PRODUCT_SALES_REPORT_FAIL"

export const GET_CATEGORY_SALES_REPORT= "GET_CATEGORY_SALES_REPORT"
export const GET_CATEGORY_SALES_REPORT_SUCCESS = "GET_CATEGORY_SALES_REPORT_SUCCESS"
export const GET_CATEGORY_SALES_REPORT_FAIL = "GET_CATEGORY_SALES_REPORT_FAIL"

export const EXPORT_CATEGORY_SALES_REPORT= "EXPORT_CATEGORY_SALES_REPORT_REPORT"
export const EXPORT_CATEGORY_SALES_REPORT_SUCCESS = "EXPORT_CATEGORY_SALES_REPORT_SUCCESS"
export const EXPORT_CATEGORY_SALES_REPORT_FAIL = "EXPORT_CATEGORY_SALES_REPORT_FAIL"

export const GET_CUSTOMER_REPORT= "GET_CUSTOMER_REPORT"
export const GET_CUSTOMER_REPORT_SUCCESS = "GET_CUSTOMER_REPORT_SUCCESS"
export const GET_CUSTOMER_REPORT_FAIL = "GET_CUSTOMER_REPORT_FAIL"

export const EXPORT_CUSTOMER_REPORT= "EXPORT_CUSTOMER_REPORT"
export const EXPORT_CUSTOMER_REPORT_SUCCESS = "EXPORT_CUSTOMER_REPORT_SUCCESS"
export const EXPORT_CUSTOMER_REPORT_FAIL = "EXPORT_CUSTOMER_REPORT_FAIL"

export const GET_MARKETING_REPORT= "GET_MARKETING_REPORT"
export const GET_MARKETING_REPORT_SUCCESS = "GET_MARKETING_REPORT_SUCCESS"
export const GET_MARKETING_REPORT_FAIL = "GET_MARKETING_REPORT_FAIL"

export const EXPORT_MARKETING_REPORT= "EXPORT_MARKETING_REPORT"
export const EXPORT_MARKETING_REPORT_SUCCESS = "EXPORT_MARKETING_REPORT_SUCCESS"
export const EXPORT_MARKETING_REPORT_FAIL = "EXPORT_MARKETING_REPORT_FAIL"

export const RESET_REPORT_STATE = 'RESET_REPORT_STATE';
export const RESET_REPORT_ATTACHMENT_STATE = 'RESET_REPORT_ATTACHMENT_STATE';